import "babel-polyfill";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { PageTitle } from "react-fast-ui";
import Promise from "bluebird";
import "fastmodel-utility-classes";
import "flexbox-css";

import "react-fast-ui/css/index.css";
import AdminPortal from "./component/AdminPortal";
import { store } from "./store";
import "../css/style.scss";

// Enable promise cancellation
Promise.config({
  cancellation: true,
});

render(
  <PageTitle>
    <Provider store={store}>
      <AdminPortal />
    </Provider>
  </PageTitle>,
  document.getElementById("root")
);
